import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Dictionary } from "src/app/store/models/common_types";
import { ReportingGridWrapperComponent } from "../reporting-grid-wrapper/reporting-grid-wrapper.component";
import { Store } from "@ngrx/store";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Subscription } from "rxjs";
import { ReportingPagesService } from "../reporting-pages.service";
import { ReportingPagesDataService } from "../reporting-pages-data.service";

@Component({
  selector: "app-reporting-sector",
  templateUrl: "./reporting-sector.component.html",
  styleUrls: ["./reporting-sector.component.scss"],
  host: { class: "sector-page-component" },
})
export class ReportingSectorComponent {
  showSearch = true;
  showGridFilters: boolean;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  globalSearchVal: string;
  coveragestatusList: Array<any> = [];
  @ViewChild(ReportingGridWrapperComponent)
  gridWrapperComp: ReportingGridWrapperComponent;
  storeSub: Subscription;
  isSellside: boolean;
  isDataSet: boolean;
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private service: ReportingPagesService,
    private dataService: ReportingPagesDataService,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
    };
    this.isDataSet = false;
    this.coveragestatusList = this.dataService.getCoverageStatusValue();
  }
  ngOnInit() {
    this.globalSearchVal = "";
    this.exportKey = `SECTOR_PAGE_${this.route.snapshot.params.sectorName}`;
    this.service.logUserOnRedirection("SECTOR_PAGE", {
      VALUE: this.route.snapshot.params.sectorName,
    });
    this.route.params.subscribe(() => {
      this.page = "sector";
      const sectorName = encodeURIComponent(
        this.route.snapshot.params.sectorName,
      );
      this.gridUrl = `api/sectorindustrydata?sector=${sectorName}&`;
      this.globalSearchVal = "";
      this.exportKey = `SECTOR_PAGE_${this.route.snapshot.params.sectorName}`;
      const columnFields = [
        {
          field: "industryname",
          renderer: "link",
        },
        {
          field: "ticker",
          renderer: "link",
        },
        {
          field: "companyname",
          renderer: "link",
        },
        {
          field: "coveragestatus",
          renderer: null,
        },
        {
          field: "coveredsource",
          renderer: null,
        },
      ];
      const columnsData = [
        [
          {
            children: 1,
            header: "Industry",
            sortKey: "industryname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Ticker",
            sortKey: "ticker",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Company",
            sortKey: "companyname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Coverage Status",
            sortKey: "coveragestatus",
            showSort: true,
            showFilter: true,
            filterType: "select",
            filterSelectValues: this.coveragestatusList,
            currentValue: "",
          },
          {
            children: 1,
            header: "Sources",
            sortKey: "coveredsource",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
        ],
      ];
      this.sortKey = "industryname";
      this.columns.columnFields = columnFields;
      this.columns.columnsData = columnsData;
      this.columns.widthConfig = ["auto", "15%", "20%", "15%", "10%"];
      this.exportColumns = columnFields.map((d) => {
        return d.field;
      });
      this.store.dispatch(new GlobalSubheaderActions.SubheaderChanged());
      this.storeSub = this.store
        .select(stateGetter("globalHeader", "globalSettings"))
        .subscribe((data: any) => {
          if (Object.keys(data).length === 0 && data.constructor === Object) {
            return;
          }
          this.isSellside = data.isSellside;
          if (this.isSellside) {
            this.columns.columnFields.push({
              field: "views",
              renderer: "report-view-link",
            });
            this.columns.columnsData[0].push({
              children: 1,
              header: "Views",
              sortKey: "views",
              showSort: false,
              showFilter: false,
            });
            this.columns.widthConfig.push("20%");
          }
          this.isDataSet = true;
        });
    });
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
  }

  onSearch(val) {
    this.globalSearchVal = val;
  }

  onReloadGrid() {
    this.gridWrapperComp.gridReload();
  }
}
